/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';

class Linkman extends React.Component {
  render() {
    return <div>
      {this.props.children}
    </div>
  }
};
export default Linkman;


// WEBPACK FOOTER //
// ./src/routes/linkman/index.js